import React from 'react';
import './css/TicketStyle.css'; // Предполагается, что стили находятся в этом файле
import backgroundImage from '../3.png'; // Импортируйте изображение

function Ticket({ number }) {
    return (
        <div className='ticket' style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'contain', // или 'contain', 'auto', и другие значения
            backgroundRepeat: 'no-repeat', // или 'repeat', 'repeat-x', 'repeat-y'
            // Другие стили вашего блока
          }}>
           {number}
        </div>
    );
}

export default Ticket;